'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../../../../../style-value-types/dist/es/numbers/index.js');
const units = require('../../../../../../style-value-types/dist/es/numbers/units.js');
require('../../../../../../style-value-types/dist/es/color/hsla.js');
require('../../../../../../style-value-types/dist/es/color/rgba.js');
require('../../../../../../style-value-types/dist/es/color/hex.js');
require('../../../../../../style-value-types/dist/es/color/index.js');
require('../../../../../../style-value-types/dist/es/complex/index.js');
require('../../../../../../style-value-types/dist/es/complex/filter.js');

function calcOrigin(origin, offset, size) {
  return typeof origin === "string" ? origin : units.px.transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */
function calcSVGTransformOrigin(dimensions, originX, originY) {
  var pxOriginX = calcOrigin(originX, dimensions.x, dimensions.width);
  var pxOriginY = calcOrigin(originY, dimensions.y, dimensions.height);
  return pxOriginX + " " + pxOriginY;
}

exports.calcSVGTransformOrigin = calcSVGTransformOrigin;
